import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Alert } from 'react-bootstrap';
import { STOREDGE } from '../../../../constants/softwareProviders';
import Button from '../../../../modules/react/components/stateless/Button';
import BasicTenantForm from '../../../../website/components/stateful/BasicTenantForm';
import Form from '../../../../modules/react/components/stateful/Form';
import Field from '../../../../modules/react/components/stateful/Field';
import LiveFacilitySelectInput from '../../containers/form/inputs/LiveFacilitySelectInput';
import withAlert from '../../../../website/hocs/withAlert';

const propTypes = {
  alert: PropTypes.node,
  facilityId: PropTypes.string,
  submitText: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
};

const defaultProps = {
  alert: undefined,
  facilityId: null,
  submitText: null,
  errorMessage: '',
};

const LeadForm = ({
  alert,
  facilityId,
  submitText,
  onSubmit,
  isSubmitting,
  errorMessage,
}) => (
  <Form form="leadForm" onSubmit={onSubmit}>
    <Row>
      <Col xs={12}>
        {alert}
        {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
        <BasicTenantForm required />
        {!facilityId &&
          <Field
            component={LiveFacilitySelectInput}
            label="Facility"
            name="facilityId"
            emptyOption=""
            required
          />
        }
      </Col>
    </Row>
    {submitText &&
      <Row className="text-center">
        <Col xs={12}>
          <Button
            type="submit"
            variant="success"
            disabled={isSubmitting}
            className="color-secondary-background color-primary-background-hover button-style-class"
          >
            {submitText}
          </Button>
        </Col>
      </Row>
    }
  </Form>
);

LeadForm.propTypes = propTypes;
LeadForm.defaultProps = defaultProps;

// We only care if storEDGE is alerting because that's where we store leads.
export default withAlert({
  Component: LeadForm,
  message: "If you're interested in renting from us or have any questions, please give us a call!",
  providers: [STOREDGE],
});
